import { Badge, Space } from 'antd';
import { AudioOutlined, ExclamationCircleTwoTone } from '@ant-design/icons';
import styled, { keyframes } from 'styled-components';
import { TextLinkButton, styleVariables } from '@lib/common';
import { RecordTimer } from './record-timer.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSpace = styled(Space).withConfig({
  displayName: "voice-record-areacomponent__StyledSpace",
  componentId: "sc-1shb76b-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;padding:25px;"]);
var pulse = keyframes(["0%{box-shadow:0 0 0 0px rgba(26,90,255,0.2);}100%{box-shadow:0 0 0 25px rgba(26,90,255,0);}"]);
var StyledAudioOutlined = styled(AudioOutlined).withConfig({
  displayName: "voice-record-areacomponent__StyledAudioOutlined",
  componentId: "sc-1shb76b-1"
})(["font-size:40px;"]);
var StyledExclamationCircleFilled = styled(ExclamationCircleTwoTone).withConfig({
  displayName: "voice-record-areacomponent__StyledExclamationCircleFilled",
  componentId: "sc-1shb76b-2"
})(["font-size:22px;color:", ";"], styleVariables.colors.gold1);
var StyledButton = styled(TextLinkButton).withConfig({
  displayName: "voice-record-areacomponent__StyledButton",
  componentId: "sc-1shb76b-3"
})(["font-size:84px;width:70px;height:70px;padding:10px;border-radius:50%;border:1px solid ", ";&:hover,&:focus{border:1px solid ", ";}&.pulse{animation:", " 2s infinite;}&::before,&::after{content:'';position:absolute;top:-20px;left:-20px;right:-20px;bottom:-20px;border-radius:50%;opacity:0;pointer-events:none;}&::before{animation:", " 2s ease-out 0s infinite;}&::after{animation:", " 2s ease-out 1s infinite;}"], styleVariables.colors.blue3, styleVariables.colors.blue3, pulse, pulse, pulse);
export var VoiceRecordArea = function VoiceRecordArea(props) {
  var isRecording = props.isRecording,
      label = props.label,
      onClick = props.onClick,
      isDenied = props.isDenied;
  return /*#__PURE__*/_jsxs(StyledSpace, {
    direction: "vertical",
    size: 'large',
    children: [/*#__PURE__*/_jsx(Badge, {
      count: isDenied ? /*#__PURE__*/_jsx(StyledExclamationCircleFilled, {
        twoToneColor: "".concat(styleVariables.colors.colorWarningBase)
      }) : /*#__PURE__*/_jsx(_Fragment, {}),
      status: "warning",
      offset: [-10, 9],
      children: /*#__PURE__*/_jsx(StyledButton, {
        shape: "circle",
        onClick: onClick,
        className: isRecording ? 'pulse' : '',
        icon: /*#__PURE__*/_jsx(StyledAudioOutlined, {})
      })
    }), isRecording ? /*#__PURE__*/_jsx(RecordTimer, {}) : isDenied ? label.permissionDenied : label.clickToStart]
  });
};